(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-header"]) return;
  try {
    
  const cartDialog = document.getElementById('lf-cart');
  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (cartDialog && typeof cartDialog.showModal === 'function') {
        cartDialog.showModal();
        document.body.classList.add('lf-lock');
      }
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach((button) => {
    button.addEventListener('click', () => {
      if (cartDialog) {
        cartDialog.close();
        document.body.classList.remove('lf-lock');
      }
    });
  });
  if (cartDialog) {
    cartDialog.addEventListener('close', () => document.body.classList.remove('lf-lock'));
  }

  } catch(e) { console.error(e); }
})();
})();
